//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { ToastService, ToastType } from '@instaclause-webapp/shared-ui';
import { Observable, of as _observableOf, throwError } from 'rxjs';
import { catchError, mergeMap as _observableMergeMap } from 'rxjs/operators';

interface RequestOptions {
  handleError: Boolean;
}

export const docsBaseUrl = new InjectionToken<string>('docsBaseUrl');

@Injectable()
export class DocumentsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(docsBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://documents.dev.instaclause.com';
  }

  /**
   * Creates task to call endpoint and generate document.
   * @param contractId The identifier of the contract for which to render the document.
   * @param documentId The identifier of the document to render.
   * @return OK
   */
  createQueue(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/queue';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateQueue(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateQueue(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateQueue(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * ⚠️[For Internal Use Only]⚠️ Generates a specific document associated with a contract, generating the final document content with all variables and clauses resolved based on the contract's data and the provided document template.
   * @param contractId The identifier of the contract for which to generate the document.
   * @param documentId The identifier of the document to generate.
   * @return OK
   */
  createGenerate(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/generate';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateGenerate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateGenerate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateGenerate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * ⚠️[For Internal Use Only]⚠️ Generates a specific document associated with a contract, generating the final document content with all variables and clauses resolved based on the contract's data and the provided document template.
   * @param contractId The identifier of the contract for which to generate the document.
   * @param documentId The identifier of the document to generate.
   * @return OK
   */
  getContext(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<string> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/context';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContext(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetContext(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<string>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<string>;
          }
        })
      );
  }

  protected processGetContext(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Retrieves a signed url for generated document associated with a contract.
   * @param contractId The identifier of the contract for which to render the document.
   * @param documentId The identifier of the document to render.
   * @return OK
   */
  getUrl(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<GetSignedUrlResponse> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/url';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUrl(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetUrl(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetSignedUrlResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetSignedUrlResponse>;
          }
        })
      );
  }

  protected processGetUrl(response: HttpResponseBase): Observable<GetSignedUrlResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetSignedUrlResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetSignedUrlResponse>(null as any);
  }

  /**
   * Opens the in-app document editor for a contract document and returns the URL to embed in the editor.
   * @param contractId The identifier of the contract the document belongs to.
   * @param documentId The identifier of the document to edit.
   * @return OK
   */
  createEdit(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<OpenDocumentEditResponse> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/edit';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateEdit(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateEdit(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<OpenDocumentEditResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<OpenDocumentEditResponse>;
          }
        })
      );
  }

  protected processCreateEdit(response: HttpResponseBase): Observable<OpenDocumentEditResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as OpenDocumentEditResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<OpenDocumentEditResponse>(null as any);
  }

  /**
   * Saves the open editing session so the PDF and DOCX downloads show the edited content.
   * @param contractId The identifier of the contract the document belongs to.
   * @param documentId The identifier of the document being edited.
   * @return OK
   */
  updateEdit(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/edit';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateEdit(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateEdit(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Closes the in-app document editor, revoking the link sharing that was granted when it was opened.
   * @param contractId The identifier of the contract the document belongs to.
   * @param documentId The identifier of the document that was being edited.
   * @return OK
   */
  deleteEdit(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/edit';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteEdit(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteEdit(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteEdit(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Throws away the manual edits and puts the document back to the version Instaclause generated.
   * @param contractId The identifier of the contract the document belongs to.
   * @param documentId The identifier of the document to restore.
   * @return OK
   */
  createRestore(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/restore';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateRestore(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateRestore(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateRestore(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * ⚠️[For Internal Use Only]⚠️ Generates a specific document associated with a contract, generating the final document content with all variables and clauses resolved based on the contract's data and the provided document template.
   * @param contractId The identifier of the contract for which to generate the document.
   * @param documentId The identifier of the document to generate.
   * @return OK
   */
  getHtml(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/html';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetHtml(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetHtml(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetHtml(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * ⚠️[For Internal Use Only]⚠️ Generates a specific document associated with a contract, generating the final document content with all variables and clauses resolved based on the contract's data and the provided document template.
   * @param contractId The identifier of the contract for which to generate the document.
   * @param documentId The identifier of the document to generate.
   * @return OK
   */
  getPdf(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/pdf';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPdf(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetPdf(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetPdf(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * ⚠️[For Internal Use Only]⚠️ Generates a specific document associated with a contract, generating the final document content with all variables and clauses resolved based on the contract's data and the provided document template.
   * @param contractId The identifier of the contract for which to generate the document.
   * @param documentId The identifier of the document to generate.
   * @return OK
   */
  getPdfGoogle(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/pdf/google';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPdfGoogle(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetPdfGoogle(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetPdfGoogle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Generates a specific document in DOCX format associated with a contract, using Google Drive integration.
   * @param contractId The identifier of the contract for which to generate the document.
   * @param documentId The identifier of the document to generate.
   * @return OK
   */
  getDocxGoogle(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/{contractId}/{documentId}/docx/google';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDocxGoogle(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetDocxGoogle(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetDocxGoogle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Generates an HTML document from the provided answers structure for a specific contract model and language.
   * @param contractModelId The identifier of the contract model.
   * @param documentId The identifier of the document.
   * @param apiKey (optional) The API key used for authorization.
   * @param languageId (optional) The identifier of the language.
   * @param body (optional) The answers structure containing contract data.
   * @return OK
   */
  createGenerateHtml(
    contractModelId: number,

    documentId: number,

    apiKey?: string | undefined,

    languageId?: number | undefined,

    body?: AnswersStructure | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/generate/{contractModelId}/{documentId}/html?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
    else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
    if (languageId === null) throw new Error("The parameter 'languageId' cannot be null.");
    else if (languageId !== undefined)
      url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateGenerateHtml(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateGenerateHtml(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateGenerateHtml(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Generates a mock HTML document using the first example value for every field, without creating any database records.
   * @param contractModelId The identifier of the contract model.
   * @param documentId The identifier of the document.
   * @param languageId (optional) The identifier of the language.
   * @return OK
   */
  getGenerateHtmlPreview(
    contractModelId: number,

    documentId: number,

    languageId?: number | undefined,
    options?: RequestOptions
  ): Observable<string> {
    let url_ = this.baseUrl + '/documents/generate/{contractModelId}/{documentId}/html/preview?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    if (languageId === null) throw new Error("The parameter 'languageId' cannot be null.");
    else if (languageId !== undefined)
      url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGenerateHtmlPreview(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetGenerateHtmlPreview(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<string>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<string>;
          }
        })
      );
  }

  protected processGetGenerateHtmlPreview(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Generates a PDF document from the provided answers structure for a specific contract model and language.
   * @param contractModelId The identifier of the contract model.
   * @param documentId The identifier of the document.
   * @param apiKey (optional) The API key used for authorization.
   * @param languageId (optional) The identifier of the language.
   * @param body (optional) The answers structure containing contract data.
   * @return OK
   */
  createGeneratePdf(
    contractModelId: number,

    documentId: number,

    apiKey?: string | undefined,

    languageId?: number | undefined,

    body?: AnswersStructure | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/generate/{contractModelId}/{documentId}/pdf?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
    else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
    if (languageId === null) throw new Error("The parameter 'languageId' cannot be null.");
    else if (languageId !== undefined)
      url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateGeneratePdf(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateGeneratePdf(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateGeneratePdf(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Generates a DOCX document from the provided answers structure for a specific contract model and language.
   * @param contractModelId The identifier of the contract model.
   * @param documentId The identifier of the document.
   * @param apiKey (optional) The API key used for authorization.
   * @param languageId (optional) The identifier of the language.
   * @param body (optional) The answers structure containing contract data.
   * @return OK
   */
  createGenerateDocx(
    contractModelId: number,

    documentId: number,

    apiKey?: string | undefined,

    languageId?: number | undefined,

    body?: AnswersStructure | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/generate/{contractModelId}/{documentId}/docx?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
    else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
    if (languageId === null) throw new Error("The parameter 'languageId' cannot be null.");
    else if (languageId !== undefined)
      url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateGenerateDocx(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateGenerateDocx(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateGenerateDocx(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Generates a PDF document from the provided answers structure for a specific contract model and language using Google Drive integration.
   * @param contractModelId The identifier of the contract model.
   * @param documentId The identifier of the document.
   * @param apiKey (optional) The API key used for authorization.
   * @param languageId (optional) The identifier of the language.
   * @param body (optional) The answers structure containing contract data.
   * @return OK
   */
  createGeneratePdfGoogle(
    contractModelId: number,

    documentId: number,

    apiKey?: string | undefined,

    languageId?: number | undefined,

    body?: AnswersStructure | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/generate/{contractModelId}/{documentId}/pdf/google?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    if (apiKey === null) throw new Error("The parameter 'apiKey' cannot be null.");
    else if (apiKey !== undefined) url_ += 'apiKey=' + encodeURIComponent('' + apiKey) + '&';
    if (languageId === null) throw new Error("The parameter 'languageId' cannot be null.");
    else if (languageId !== undefined)
      url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateGeneratePdfGoogle(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateGeneratePdfGoogle(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateGeneratePdfGoogle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Sends a snapshot structure for a specific contract model and language.
   * @param contractModelId The identifier of the contract model.
   * @param languageId The identifier of the language.
   * @return OK
   */
  createPublish(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/documents/publish/{contractModelId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePublish(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreatePublish(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreatePublish(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class FilesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(docsBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://documents.dev.instaclause.com';
  }

  /**
   * Uploads a file associated with a specific contract and document.
   * @param file (optional) Gets or sets the file to be uploaded.
   * @return OK
   */
  createUpload(
    file?: FileParameter | undefined,
    options?: RequestOptions
  ): Observable<FileUploadResponseDto> {
    let url_ = this.baseUrl + '/files/upload';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUpload(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUpload(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<FileUploadResponseDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<FileUploadResponseDto>;
          }
        })
      );
  }

  protected processCreateUpload(response: HttpResponseBase): Observable<FileUploadResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as FileUploadResponseDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<FileUploadResponseDto>(null as any);
  }

  /**
   * Retrieves an image file associated with a specific document.
   * @param customerId The identifier of the user customer.
   * @param fileName The name of the file to retrieve.
   * @return OK
   */
  get(
    customerId: number,

    fileName: string,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/files/{customerId}/{fileName}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (fileName === undefined || fileName === null)
      throw new Error("The parameter 'fileName' must be defined.");
    url_ = url_.replace('{fileName}', encodeURIComponent('' + fileName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves a JSON file containing the snapshot structure for a specific contract model.
   * @param contractModelId The identifier of the contract model.
   * @param languageId The identifier of the language.
   * @return OK
   */
  getAdapter(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/files/adapter/{contractModelId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAdapter(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetAdapter(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetAdapter(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves a JSON file containing the snapshot structure for a specific contract model.
   * @param contractModelId The identifier of the contract model.
   * @param languageId The identifier of the language.
   * @return OK
   */
  getAdapterJson(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/files/adapter/{contractModelId}/json?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAdapterJson(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetAdapterJson(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetAdapterJson(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

/** Represents the structure of answers for a document. */
export interface AnswersStructure {
  /** Gets or sets the dictionary of answers. */
  answers: { [key: string]: string };
  /** Gets or sets the user email associated with the answers. */
  userEmail?: string | undefined;
}

/** Represents a data transfer object for the response of a file upload. */
export interface FileUploadResponseDto {
  /** Gets or sets the file name. */
  fileName: string;
  /** Gets or sets the customer id. */
  customerId: number;
}

/** Represents the response to a request to add a role to a contract model. */
export interface GetSignedUrlResponse {
  /** Wrapper with status flag. */
  documentInfo: SignedUrlDto;
}

/** Represents the response to a request to open the in-app document editor. */
export interface OpenDocumentEditResponse {
  /** The URL of the Google Doc to display in the editor iframe. */
  embedUrl: string;
}

/** Represents a signed URL response for a document. */
export interface SignedUrlDto {
  /** Indication that document is ready. */
  isReady: boolean;
  /** Retrieved signed url. */
  url?: string | undefined;
  /** Whether the returned URL points to a digitally signed version of the document. */
  isSigned: boolean;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) {
    return throwError(() => result);
  }

  return throwError(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
